import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import {
    TAnnex6BackendRecord,
} from '../../../../../redux/app/annex6/@types';
import { IStore } from '../../../../../redux/store';
import Annex6Previewer from './Annex6Previewer';
import Annex6RecordParticipantsView from '../ParticipantsView';
import Annex6AttachmentPrintView from '../Annex6AttachmentPrintView';
import { vesselSelectors } from 'redux/app/vessel';

type OwnProps = {
    annex6Records: TAnnex6BackendRecord[];
    isPrintVisible: boolean;
	vesselId: string;
};
type Annex6PrintProps = OwnProps & PropsFromRedux;
function Annex6Print(props: Annex6PrintProps) {
    const { isPrintVisible, annex6Records } = props;
    if (!isPrintVisible) return null;
    return (
        <div className="w-full p-12">
            <div className="mb-8">
                <h3 className="w-3/4 mb-6 text-base font-medium leading-5 tracking-wide text-gray-600">
                    Annex VI Operations
                </h3>
            </div>
            <div className="w-full bg-gray-100">
                <table className="w-full bg-gray-100 marpol-table annex6-table h-full">
                    <thead className="h-full">
                        <tr className="bg-gray-100 h-full">
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-28 h-full flex justify-center items-center">
                                    Date
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-center text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex flex-col justify-center items-center">
                                    <p style={{ margin: 0 }}>Code</p>
                                    <p style={{ margin: 0 }} className="m-0">
                                        (Letter)
                                    </p>
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-right text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex flex-col justify-center items-center">
                                    <p style={{ margin: 0 }}>Item</p>
                                    <p style={{ margin: 0 }} className="m-0">
                                        (number)
                                    </p>
                                </div>
                            </th>
                            <th className="h-full">
                                <div className="p-3 m-px text-xs font-medium leading-4 tracking-wide text-left text-gray-600 bg-gray-200 border-gray-300 whitespace-nowrap min-w-20 h-full flex justify-center items-center">
                                    Record of operations/signature of officer in
                                    charge
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {annex6Records.map((annex6Record, index) => {
                            const isSubmitterChiefOrMaster =
                                annex6Record.approvedBy
                                    ? annex6Record.approvedBy.staffId ===
                                      annex6Record.submittedBy?.staffId
                                    : false;
                            return (
                                <React.Fragment key={annex6Record.id}>
                                    <Annex6Previewer
                                        annex6Record={annex6Record}
                                        theme="light"
                                    />
                                    <Annex6AttachmentPrintView
                                        annex6Record={annex6Record}
                                    ></Annex6AttachmentPrintView>
                                    <Annex6RecordParticipantsView
                                        isSubmitterChiefOrMaster={
                                            isSubmitterChiefOrMaster
                                        }
                                        annex6Record={annex6Record}
                                    />
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    return {
        vesselName: vesselInfo?.vesselName,
        imoNumber: vesselInfo?.imoNumber,
    };
}
const reduxConnector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(Annex6Print);
